import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { FAQSection } from '../components/FAQSection';
import { ContactCTA } from '../components/ContactCTA';
export function FAQPage() {
  return <main className="bg-light min-h-screen" data-id="element-747">
      <PageBanner title="Frequently Asked Questions" subtitle="Find answers to common questions about our home healthcare services." breadcrumbs={[{
      label: 'FAQs',
      path: '/faq'
    }]} data-id="element-748" />
      <FAQSection data-id="element-749" />
      <ContactCTA data-id="element-750" />
    </main>;
}